export const STANDARD_EASING = 'cubic-bezier(0.4, 0.14, 0.3, 1)';
export const ENTRANCE_EASING = 'cubic-bezier(0, 0, 0.3, 1)';
export const EXIT_EASING = 'cubic-bezier(0.4, 0.14, 1, 1)';

export const STANDARD_TIME = 0.3;
export const ENTRANCE_TIME = 0.3;
export const EXIT_TIME = 0.15;
